
export const setUser = ({ commit }, payload) => {
    commit("setUser", payload);
};
